export enum NotificationChannelOptions {
	MAIL = 'MAIL'
}

export type NotificationChannel = `${NotificationChannelOptions}`;

export function hasNotificationChannel(
	channels: NotificationChannel[] | undefined,
	channel: NotificationChannel
): boolean {
	return !!channels?.includes(channel);
}
